export default __webpack_public_path__ + "static/img-merit02-9195a2adb2b4397a7f69832dd68b22c5.svg";